import {MenuDivider, MenuItem} from '@szhsin/react-menu'
import {EditIcon, HorizontalMoreIcon, TrashIcon} from '../../../icons'
import Dropdown from '../../core/dropdown'
import {colors} from '../../../utils/colors'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import {envConfig} from '../../../utils/env'

const {isReadOnlyModeEnabled} = envConfig

const ActionButtons = ({
    onEdit,
    isEditBtnDisabled,
    showEdit = true,
    showDelete = true,
    onDelete
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const text = useNamespaceTranslations('actions')

    return <Dropdown menuButton={<button className={classNames('table-action-btn', {
        dark: isDarkMode
    })}><HorizontalMoreIcon/></button>}>
        {showEdit && <MenuItem onClick={onEdit} disabled={isEditBtnDisabled || isReadOnlyModeEnabled}>
            <span className="d-flex"><EditIcon/></span>
            <span>{text.edit}</span>
        </MenuItem>}
        {showDelete &&
            <>
                <MenuDivider/>
                <MenuItem className="danger" onClick={onDelete} disabled={isReadOnlyModeEnabled}>
                    <span className="d-flex"><TrashIcon stroke={colors.colorRed}/></span>
                    <span>{text.delete}</span>
                </MenuItem>
            </>}
    </Dropdown>
}

export default ActionButtons
